import { render, staticRenderFns } from "./Gallery5.vue?vue&type=template&id=147e31ba&scoped=true"
import script from "./Gallery5.vue?vue&type=script&lang=ts"
export * from "./Gallery5.vue?vue&type=script&lang=ts"
import style0 from "./Gallery5.vue?vue&type=style&index=0&id=147e31ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147e31ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
